import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import { setApiError, togglePopover } from "../../admin/app-slice";
import {AppDispatch} from "../../core/store";
import {ApiInstance} from "../../services/api";
import {formValidator} from "./validator";

const initialState = {
  customers: [],
  customer: null,
  form:{
    name: '',
    primary_phone:'',
    email:'',
    address:'',
    city: ''
  },
  validationFields:{

  } as any,
  formValid: true,
}

const customer = createSlice({
  name: 'customer',
  initialState: initialState,
  reducers: {
    setCustomers: (state, action: PayloadAction<any>) => {
      state.customers = action.payload
      return state
    },
    setCustomer: (state, action: PayloadAction<any>) => {
      state.customer = action.payload
      return state
    },
    handleFormChange: (state, action: PayloadAction<{ key: string, value: any }>) => {
      const data = action.payload
      state.form[data.key] = data.value
      return state
    },
    resetForm: (state)=>{
      state.form = initialState.form
      return state
    },
    validateInputs: (state, action: PayloadAction<any>) => {
      if (Array.isArray(action.payload)) {
        action.payload.forEach((el => {
          state.validationFields = formValidator(state.validationFields, el)
        }))
      } else {
        state.validationFields = formValidator(state.validationFields, action.payload)
      }
      state.formValid = Object.keys(state.validationFields).every(k => state.validationFields[k] !== false);

      return state
    },
  }
});

export const {
  setCustomers,
  setCustomer,
  handleFormChange,
  validateInputs,
  resetForm
} = customer.actions;

export const getCustomers = (filter = {}) => {
  return async (dispatch: AppDispatch, getState: any, api: ApiInstance) => {
    try {
      const res = await api.admin.get('customer', filter)
      dispatch(setCustomers(res))
      return res
    } catch (e) {
      dispatch(setApiError(e))
    }
  }
}

export const createCustomer = () => {
  return async (dispatch: AppDispatch, getState: any, api: ApiInstance) => {
    const customer = getState().customer

    if (customer.formValid) {
      const data = {...customer.form}
      try {
        await api.admin.post('customer', {...data})
        dispatch(togglePopover('customerAddOrganization'))
        await dispatch(getCustomers())
        await dispatch(clearForm())
      } catch (e) {
        console.error('failed to create customer with error:', e)
        dispatch(setApiError(e))
      }
    }
  }
};

export const updateCustomer = () => {
  return async (dispatch: AppDispatch, getState: any, api: ApiInstance) => {
    const customer = getState().customer

    if (customer.formValid) {
      try {
        await api.admin.put(`customer/${customer.customer.uuid}`, customer.form)
        dispatch(togglePopover('customerAddOrganization'))
        await dispatch(clearForm())
        return await dispatch(getCustomers())
      } catch (e) {
        console.error('failed to create customer with error:', e)
        dispatch(setApiError(e))
      }
    }
  }
};

export const selectCustomer = (data) => {
  return (dispatch: AppDispatch) => {
    dispatch(setCustomer(data))
  }
}

export const clearForm = () => {
  return (dispatch: AppDispatch) => dispatch(resetForm())
}

export const deleteCustomer = (uuid: string) => {
  return async (dispatch: AppDispatch, getState: any, api: ApiInstance) => {
    try {
      return await api.admin.delete(`/customer/${uuid}`)
    } catch (e) {
      dispatch(setApiError(e))
    }
  }
}

export const formFields = Object.keys(initialState.form)

export default customer.reducer;
